import type { ComputerViewModelExtended } from './computer-view-model-extended';

/**
 * Computers with a given network uuid
 *
 * @param computers
 * @param networkUuid
 * @returns {*}
 */
export function computersInNetwork(
  computers: ComputerViewModelExtended[],
  networkUuid: string,
): ComputerViewModelExtended[] {
  return computers.filter((c) => c.networkUuid === networkUuid);
}
